import { Bucket } from '@kaizenplatform/creative-search-entity';
/**
 * creativeをソートする関数のcomparator.
 * アルファベット順にソート、otherを最後に持ってくる.
 */
export const sortFunc = (a: Bucket, b: Bucket) => {
  const aText = a.value.toString().toLowerCase();
  const bText = b.value.toString().toLowerCase();
  if (aText === bText) {
    return 0;
  }
  if (aText === 'other') {
    return 1;
  }
  if (bText === 'other') {
    return -1;
  }
  if (aText === 'owned_media') {
    return 1;
  }
  if (bText === 'owned_media') {
    return -1;
  }
  if (bText < aText) return 1;
  else if (bText > aText) return -1;
  return 0;
};
